import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const tipoProyectoService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('TipoProyecto/GetAll/')
}
